import React, { useState } from "react";
import "../../Assets/Css/SetDate.css";
import SetSlot from "../../Components/SetSlot/SetSlot";
import SetConfirm from "../../Components/SetConfirm/SetConfirm";

const SetDate = ({ onBackToPrevious }) => {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(""); // State for selected slot
  const [activeComponent, setActiveComponent] = useState("setDate");

  // Default next follow-up date: tomorrow
  const nextFollowUpDate = new Date(today);
  nextFollowUpDate.setDate(today.getDate() + 1);

  // Format date as dd/mm/yyyy
  const formatDate = (date) => {
    if (!date) return null; // Handle null case gracefully
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Generate calendar dates for the current month
  const generateCalendarDates = () => {
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const daysInCurrentMonth = new Date(
      currentYear,
      currentMonth + 1,
      0
    ).getDate();

    const calendar = [];
    let week = [];

    // Add empty spaces for days before the 1st of the month
    for (
      let i = 0;
      i < (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1);
      i++
    ) {
      week.push(null);
    }

    // Add current month's dates
    for (let day = 1; day <= daysInCurrentMonth; day++) {
      week.push({ day, isCurrentMonth: true });

      if (week.length === 7) {
        calendar.push(week);
        week = [];
      }
    }

    // Add next month's dates
    let nextMonthDay = 1;
    while (week.length < 7) {
      week.push({ day: nextMonthDay, isCurrentMonth: false });
      nextMonthDay++;
    }
    calendar.push(week);

    return calendar;
  };

  const handleDateClick = (day, isCurrentMonth) => {
    if (isCurrentMonth) {
      const selected = new Date(currentYear, currentMonth, day);
      setSelectedDate(selected);
    }
  };

  const handleMonthChange = (direction) => {
    if (direction === "prev") {
      setCurrentMonth((prev) => (prev === 0 ? 11 : prev - 1));
      if (currentMonth === 0) setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => (prev === 11 ? 0 : prev + 1));
      if (currentMonth === 11) setCurrentYear((prev) => prev + 1);
    }
  };

  const handleNextFromSetSlot = (slot) => {
    setSelectedSlot(slot); // Capture selected slot
    setActiveComponent("setConfirm");
  };

  const handleNextClick = () => {
    setActiveComponent("setSlot");
  };

  const handleBackToSetDate = () => {
    setActiveComponent("setDate");
  };

  const handleBackToSetSlot = () => {
    setActiveComponent("setSlot");
  };

  const handleCloseSetConfirm = () => {
    setActiveComponent("setSlot");
  };

  const calendarDates = generateCalendarDates();

  return (
    <div>
      {activeComponent === "setDate" && (
        <div className="set-date-wrapper raslide-up">
          <div className="set-date-container">
            <div className="set-date-header">Set Date</div>
            <div className="set-date-calendar">
              <div className="set-date-calendar-header">
                <span className="set-date-month">
                  {new Date(currentYear, currentMonth).toLocaleString(
                    "default",
                    {
                      month: "long",
                    }
                  )}{" "}
                  {currentYear}
                </span>
                <div className="set-date-nav-buttons">
                  <button
                    className="set-date-nav-button"
                    onClick={() => handleMonthChange("prev")}
                  >
                    &lt;
                  </button>
                  <button
                    className="set-date-nav-button"
                    onClick={() => handleMonthChange("next")}
                  >
                    &gt;
                  </button>
                </div>
              </div>
              <table className="set-date-calendar-table">
                <thead>
                  <tr>
                    <th>Mo</th>
                    <th>Tu</th>
                    <th>We</th>
                    <th>Th</th>
                    <th>Fr</th>
                    <th>Sa</th>
                    <th>Su</th>
                  </tr>
                </thead>
                <tbody>
                  {calendarDates.map((week, index) => (
                    <tr key={index}>
                      {week.map((cell, dayIndex) => {
                        const isToday =
                          cell &&
                          cell.isCurrentMonth &&
                          new Date(
                            currentYear,
                            currentMonth,
                            cell.day
                          ).toDateString() === today.toDateString();

                        return (
                          <td
                            key={dayIndex}
                            className={`${
                              cell
                                ? cell.isCurrentMonth
                                  ? "set-date-current"
                                  : "set-date-next-month"
                                : "set-date-empty"
                            } ${
                              selectedDate &&
                              cell &&
                              cell.isCurrentMonth &&
                              selectedDate.toDateString() ===
                                new Date(
                                  currentYear,
                                  currentMonth,
                                  cell.day
                                ).toDateString()
                                ? "set-date-selected"
                                : ""
                            } ${isToday ? "set-date-today" : ""}`}
                            onClick={() =>
                              cell &&
                              handleDateClick(cell.day, cell.isCurrentMonth)
                            }
                          >
                            {cell ? cell.day : ""}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="set-date-follow-up">
              Next Follow-up:{" "}
              <span className="set-date-follow-up-date">
                {formatDate(nextFollowUpDate)}{" "}
                {/* Always show default tomorrow's date */}
              </span>
              <br />
              <br />
              {selectedDate && (
                <div>
                  Selected Date:{" "}
                  <span className="set-date-follow-up-date">
                    {formatDate(selectedDate)}{" "}
                    {/* Show the user-selected date */}
                  </span>
                </div>
              )}
            </div>

            <div className="set-date-buttons">
              <button
                className="set-date-button set-date-back-button"
                onClick={onBackToPrevious}
              >
                Back
              </button>
              <button
                className="set-date-button set-date-next-button"
                onClick={handleNextClick}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {activeComponent === "setSlot" && (
        <div className="set-slot-wrapper raslide-up">
          <SetSlot
            onBack={handleBackToSetDate}
            onNext={(slot) => handleNextFromSetSlot(slot)}
          />
        </div>
      )}

      {activeComponent === "setConfirm" && (
        <SetConfirm
          onBack={handleBackToSetSlot}
          onClose={handleCloseSetConfirm}
          selectedDate={formatDate(selectedDate)} // Only pass the selectedDate
          nextFollowUpDate={formatDate(nextFollowUpDate)} // Pass nextFollowUpDate separately
          selectedSlot={selectedSlot} // Pass slot
        />
      )}
    </div>
  );
};

export default SetDate;
